import React from "react";
import { Box, Typography } from "@mui/material";
import DuelCard from "./DuelCard";

export default function BracketRound({
                                         round,
                                         title,
                                         onWinnerSelected,
                                         onPhotoFinishToggle,
                                         onJuryDecisionToggle,
                                         onSetActive,
                                         onClearActive,
                                         activeMatchId,
                                     }) {
    if (!round || round.length === 0) return null;

    return (
        <Box sx={{ mb: 4 }}>
            <Typography
                variant="h6"
                sx={{ mb: 2, fontWeight: "bold", textAlign: "center" }}
            >
                {title}
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    justifyContent: "center"
                }}
            >
                {round.map((duel) => (
                    <DuelCard
                        key={duel.id}
                        duel={duel}
                        onWinnerSelected={onWinnerSelected}
                        onPhotoFinishToggle={onPhotoFinishToggle}
                        onJuryDecisionToggle={onJuryDecisionToggle}
                        onSetActive={onSetActive}
                        onClearActive={onClearActive}
                        isActive={activeMatchId === duel.id}
                    />
                ))}
            </Box>
        </Box>
    );
}